import { ListItem, styled } from "@mui/material";

const StripedListItem = styled(ListItem)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: "white",
    },
    '&:nth-of-type(even)': {
      backgroundColor: "rgb(240,240,240)",
    },
}));

export default StripedListItem;